const bisButton = document.querySelector('.klaviyo-bis-trigger');
const bisModal = document.getElementById('klaviyoBisModal');
const closeButton = document.getElementById('closeKlaviyoModal');

var productVariantID = document.querySelector('input[name="id"]')?.value || bisButton?.dataset?.selected_var_id; // Get Shopify Variant ID dynamically

if (bisButton && bisModal) {
  bisButton.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent page scroll/jump
    bisModal.classList.add('show');
    document.body.classList.add('overflow-hidden');
    var skuElement = document.querySelector('.product__sku span');
    var productSKU = skuElement ? skuElement.getAttribute('data-product-sku') : 'N/A';
    productVariantID = document.querySelector('input[name="id"]')?.value || bisButton?.dataset?.selected_var_id;

    document.querySelector('.klaviyobis-modal__sku').innerHTML = `SKU: ${productSKU}`;
  });
}

if (closeButton && bisModal) {
  closeButton.addEventListener('click', function () {
    bisModal.classList.remove('show');
    document.body.classList.remove('overflow-hidden');
  });

  window.addEventListener('click', function (event) {
    if (event.target === bisModal) {
      bisModal.classList.remove('show');
      document.body.classList.remove('overflow-hidden');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('klaviyo-back-in-stock-form');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const email = document.getElementById('klaviyo-bis-email').value;

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${productVariantID}`,
              },
            },
          },
        },
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoModal.klaviyo_api}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
        })
        .then(() => {
          document.getElementById('klaviyo-bis-success').style.display = 'block';
          form.reset();
        })
        .catch((error) => console.error('Error:', error));
    });
  }
});
